export default __webpack_public_path__ + "static/media/products-inactive.caefd88b.svg";